export default "/images/ds-logo.png?32d731e91636a376ef25269716a13965";